export default {"src":"/_next/static/media/Help.604323aa.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};